import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Paper, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, CircularProgress } from '@mui/material';
import { operationsService } from '../services/operationsService';

export default function OperationsPage() {
  const [tab, setTab] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let result = [];
      if (tab === 0) result = await operationsService.offers.getAll();
      else if (tab === 1) result = await operationsService.tenancies.getAll();
      else if (tab === 2) result = await operationsService.maintenanceRequests.getAll();
      else if (tab === 3) result = await operationsService.appointments.getAll();
      
      setData(Array.isArray(result) ? result : result.results || []);
    } catch (e) {
      console.error(e);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [tab]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, minHeight: '100vh', background: '#F4F6FB' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#1A1A2E' }}>Operations Dashboard</Typography>
        <Typography variant="body2" sx={{ color: '#888', mt: 0.5 }}>Manage offers, tenancies, maintenance, and appointments.</Typography>
      </Box>

      <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid #E8EAF0', overflow: 'hidden' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: '1px solid #E0E0E0', px: 2 }}>
          <Tab label="Offers" />
          <Tab label="Tenancies" />
          <Tab label="Maintenance" />
          <Tab label="Appointments" />
        </Tabs>
        
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ background: '#F8F5FF' }}>
                <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Created / Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={3} align="center"><CircularProgress size={24}/></TableCell></TableRow>
              ) : data.length === 0 ? (
                <TableRow><TableCell colSpan={3} align="center">No data found</TableCell></TableRow>
              ) : (
                data.map((item) => (
                  <TableRow key={item.id} hover>
                    <TableCell>{item.id}</TableCell>
                    <TableCell><Chip label={item.status || 'Active'} size="small" /></TableCell>
                    <TableCell>{new Date(item.created_at || item.appointment_date).toLocaleDateString()}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
